import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetFormRecordWithValue,
  CleanUpFormRecordWithValueList,
} from '../../store/ExtraInformation/extraInformationSlice';

const useFormRecords = (tableId, referenceId) => {
  const dispatch = useDispatch();
  const [refreshData, setRefreshData] = useState(true);
  const { FormRecordWithValueList } = useSelector((state) => state.ExtraInformation);

  useEffect(() => {
    if (refreshData) {
      dispatch(
        GetFormRecordWithValue({
          TableId: tableId,
          ReferenceId: referenceId,
        })
      );
      setRefreshData(false);
    }

    return () => {
      dispatch(CleanUpFormRecordWithValueList());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshData, tableId, referenceId]);

  return { FormRecordWithValueList, setRefreshData };
};

export default useFormRecords;
